<ac-drop-down #userActionDropDown parentClass="user-action-dropdown" #mainMenu>
  <div id="user-menu-toggle" class="main-menu-open header-toolbar-action flexRowParent" parent [class.open]="mainMenu.isOpen">
    <span class="separator"></span>
    <span class="welcome">Welcome&nbsp;</span>

    <span>{{name}}</span>

    <ac-svg class="ovoc-menu" name="chevron" rotate="270" width="8px" height="18px"></ac-svg>
  </div>

  <user-menu id="user-menu-content" (actionClick)="userActionDropDown.close()" tooltip></user-menu>
</ac-drop-down>
